import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import "./PdfViewerModal.css";

const PdfViewerModal = ({ isOpen, toggle, fileUrl, title }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" centered scrollable className="om-modal">
      <ModalHeader toggle={toggle} className="om-modal-header">{title}</ModalHeader>

      <ModalBody className="om-modal-body pdf-modal-body">
        {fileUrl ? (
          <iframe
            src={fileUrl}
            title="PDF Viewer"
            width="100%"
            height="100%"
            className="pdf-modal-iframe"
          />
        ) : (
          <div className="text-center p-4 text-muted">
            Document not available
          </div>
        )}
      </ModalBody>

      <ModalFooter className="om-modal-footer">
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PdfViewerModal;
